import React from "react"

const Buses = () => {
  return (
    <div className='buses'>
      <div className='header'>
        <i className='nc-icon nc-bus-front-12' />
        <div>Buses</div>
      </div>
      <ul>
        <li className='mb-3'>
          Each order that was assigned to a bus can be found here
        </li>
        <li className='mb-3'>
          There is a place to add notes, a driver or the status of the bus
        </li>
        <li>
          Additional Options
          <div className='action'>
            <button
              className='btn btn-primary btn-xs mr-2'
              style={{ backgroundColor: "red" }}
            >
              <i className='fa fa-check' />
            </button>
            <div>
              Complete an order (generally done in the warehouse section)
            </div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-upload' />
            </button>
            <div>Push the order to CES Starboard</div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-list' />
            </button>
            <div>
              Can view the orders that make up the bus. Also there is the option
              to update order details if there were changes on Sylectus that are
              not reflected in the bus
            </div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-save' />
            </button>
            <div>
              Can update the details of the bus to reflect the current status
            </div>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default Buses
